/*eslint-disable eqeqeq*/
import React from 'react';
import CityList from '../../component/componentCity/citylist';
// import { data } from './citydata'
import * as APIController from '../../../../api/APIController.js';
import Notification from '../../../../shared/components/notification/notification';

class CityContainer extends React.Component {

    state = {
        currentPage: 0,
        count: 0,
        list: [],
        rowsPerPage: 10,
        rowsPerPageOptions: [10, 25, 50, 'All'],
        from: 0,
        to: 10,
        progress: true,
        message: '',
        showNotification: false,
        isError: false,
        showMessage: this.props.history.location.state != null && this.props.history.location.state.showMessage
    }

    componentDidMount() {
        this.wsGetCities(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to);
        this.state.showMessage != '' && this.handleNotification(this.state.showMessage)
        this.props.history.replace('/city', null);
    }
    handlebind() {
        this.wsGetCities(this.state.currentPage, this.state.rowsPerPage)
    }

    wsGetCities(CurrentPage, RecordPerPage, from, to, CountryName, StateName, CityName, IsActive) {
        this.setState({ progress: true, });
        APIController.GetCities(CurrentPage, RecordPerPage, CountryName, StateName, CityName, IsActive)
            .then((response) => {
                if (response.object.status == 0 && response.object.data.length != 0) {
                    this.setState({
                        to: isNaN(to) ? 1000000 : to,
                        from: from,
                        count: response.object.data[0].MaxRows,
                        list: response.object.data,
                        progress: false,
                    })
                }
                else if (response.object.message && response.object.message.length > 0) {
                    // ToastsStore.warning(response.error.message)
                } else { this.setState({ list: [], progress: false }) }
            })
    }

    render() {
        return (
            <>
                <Notification
                    isError={this.state.isError}
                    message={this.state.message}
                    showNotification={this.state.showNotification}
                    clearNotification={this.handleClearNotification}
                    closeNotification={this.handleClearNotification}
                />
                <section className="content-right-main">
                    <div className="button-field button-field-country">
                        <button onClick={() => {
                            this.props.history.push({
                                pathname: '/city/add',
                                state: { cityIdEdit: '0', countryIdEdit: '', stateIdEdit: '', cityNameEdit: '', cityActiveEdit: 1 }
                            })
                        }}>+ Add City</button>
                    </div>
                    <CityList {...this.state}
                        history={this.props.history}
                        handlebind={this.handlebind.bind(this)}
                        handleChangeRowsPerPage={this.handleRowsPerPageChange}
                        handleChangePage={this.handlePageChange}
                        applyFilter={this.handleApplyFilter}
                    />
                </section>
            </>
        )
    }

    /**
     * handleRowsPerPageChange method is used to update rows per page
     * it will reset page to 1
     */
    handleRowsPerPageChange = (value, CityText, StateText, CountryText, IsActive) => {
        let from = 0
        let to = value;
        this.setState({ rowsPerPage: value, currentPage: 1, to: to, from: from })
        this.wsGetCities(isNaN(value) ? '' : this.state.currentPage, isNaN(value) ? 1000000 : value, from, to, CountryText, StateText, CityText, IsActive);
    }

    /**
     * handlePageChange method is used to change page
     */
    handlePageChange = (values, CityText, StateText, CountryText, IsActive) => {
        let from = values === 1 ? 0 * this.state.rowsPerPage : (values - 1) * this.state.rowsPerPage
        let to = values === 1 ? this.state.rowsPerPage : parseInt(from) + parseInt(this.state.rowsPerPage);
        this.setState({ currentPage: Number(values), to: to, from: from })
        this.wsGetCities(Number(values), this.state.rowsPerPage, from, to, CountryText, StateText, CityText, IsActive);
    }

    /**
     * handleApplyFilter method is used to apply filter on every columns
     */
    handleApplyFilter = (CityText, StateText, CountryText, IsActive) => {
        this.wsGetCities(this.state.currentPage, this.state.rowsPerPage, this.state.from, this.state.to, CountryText, StateText, CityText, IsActive)
    }

    handleNotification = (message, isError) => {

        this.setState({
            message: message,
            showNotification: true,
            isError: isError
        })

        setTimeout(() => {
            this.handleClearNotification();
        }, 4000)
    }

    handleClearNotification = () => {
        this.setState({
            message: '',
            showNotification: false,
            isError: false
        })
    }

}

export default CityContainer;